module.exports = __webpack_public_path__ + "static/media/cancer-and-covid-19-news.d65b9399.jpg";